module.exports = __webpack_public_path__ + "bd.6ab6bba3.svg";